import React from 'react';
import { useUnreadCountStore } from '../NotificationCenterStore';
import { Button } from '@mui/material';
import { useShallow } from 'zustand/shallow';

/**
 * @typedef {object} FooterProps
 * @property {(event: React.MouseEvent<HTMLButtonElement>) => void} handleMarkAllAsReadClick
 * @property {boolean} [disableMarkAllAsRead]
 */

/**
 * @param {FooterProps} props
 */
const Footer = props => {
  const { handleMarkAllAsReadClick, disableMarkAllAsRead = true } = props;

  const unreadCount = useUnreadCountStore(useShallow(state => state.unreadCount));

  return (
    <div className='notification-footer'>
      <Button
        className='secondary-button sm mark-all-read-btn'
        style={{}}
        onClick={handleMarkAllAsReadClick}
        disabled={disableMarkAllAsRead || unreadCount === 0}>
        Mark All as Read
      </Button>
    </div>
  );
};

export default Footer;
